// Need to use the React-specific entry point to import createApi
import { createApi } from "@reduxjs/toolkit/query/react";
import type { ExternalAPIKey, CreateAPIKeyRequest, CreateAPIKeyResponse, RegeneratePATRequest } from "@/types/external-api.type";
import { baseRestQueryResult as baseQuery, showNotification } from "@/services/api";

// Define a service using a base URL and expected endpoints
export const externalApiApi = createApi({
  reducerPath: "externalApiApi",
  baseQuery,
  tagTypes: ['ExternalAPIKey'],
  endpoints: (builder) => ({
    getAPIKey: builder.query<ExternalAPIKey, void>({
      query: () => 'admin/external-api/key',
      keepUnusedDataFor: 0,
      providesTags: ['ExternalAPIKey'],
      transformResponse: (rawResult: {data: ExternalAPIKey}, meta) => {
        return rawResult.data
      },
    }),
    createAPIKey: builder.mutation<CreateAPIKeyResponse, CreateAPIKeyRequest>({
      query: (body) => ({
        url: 'admin/external-api/key',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['ExternalAPIKey'],
      async onQueryStarted(body, { queryFulfilled }) {
        try {
          const { data, meta } = await queryFulfilled
          // `onSuccess` side-effect
          showNotification("POST", "success")
        } catch (err: any) {

          // `onError` side-effect
          showNotification("POST", "error", err?.error?.data?.message || "error")
        }
    }
    }),
    regenerateAPIKey: builder.mutation<CreateAPIKeyResponse, RegeneratePATRequest>({
      query: (body) => ({
        url: 'admin/external-api/key',
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['ExternalAPIKey'],
      async onQueryStarted(body, { queryFulfilled }) {
        try {
          const { data, meta } = await queryFulfilled
          // `onSuccess` side-effect
          showNotification("POST", "success")
        } catch (err: any) {

          // `onError` side-effect
          showNotification("POST", "error", err?.error?.data?.message || "error")
        }
    }
    }),
    deleteAPIKey: builder.mutation<any, void>({
      query: () => ({
        url: 'admin/external-api/key',
        method: 'DELETE',
      }),
      invalidatesTags: ['ExternalAPIKey'],
      async onQueryStarted(body, { queryFulfilled }) {
        try {
          const { data, meta } = await queryFulfilled
          // `onSuccess` side-effect
          showNotification("DELETE", "success")
        } catch (err: any) {

          // `onError` side-effect
          showNotification("DELETE", "error", err?.error?.data?.message || "error")
        }
    }
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAPIKeyQuery,
  useCreateAPIKeyMutation,
  useRegenerateAPIKeyMutation,
  useDeleteAPIKeyMutation
} = externalApiApi;
